import React, {useContext} from "react";
import {observer} from "mobx-react-lite";
import ReportStore from "../../../stores/backoffice/reports/ReportStore";
import {pageStoreContext} from "../../../pages/backoffice/BackReportsPage";

interface Props {
  report: ReportStore;
}

const ReportColumns:React.FC<Props> = observer(({report}) => {
  const pageStore = useContext(pageStoreContext);
  const model = report?.model;
  if (!model || !model.visible_columns) return null;

  const fieldIds = model.visible_columns.split(",");
  
  const fieldIdToName = new Map<string, string>();
  if (pageStore?.applicationsConfig?.available_fields) {
    pageStore.applicationsConfig.available_fields.forEach(f => {
      fieldIdToName.set(f.id, f.name);
    });
  }

  const columnNames = fieldIds.map(id => fieldIdToName.get(id) || id);
  const displayColumns = columnNames.length > 5 
    ? `${columnNames.slice(0, 5).join(", ")}... (${columnNames.length} total)`
    : columnNames.join(", ");

  return (
    <div className="mt-2 text-muted">
      <small>Columns: {displayColumns}</small>
    </div>
  );
});

export default ReportColumns;
